import { Button } from "@material-ui/core";
import React from "react";
import "../../css/Profile/ProfileSide.css";
import HomeWorkIcon from "@material-ui/icons/HomeWork";

function ProfileSide() {
  return (
    <div className="profileSide">
      <div className="profileSide__intro">
        <h4>Intro</h4>
        <p>
          <HomeWorkIcon></HomeWorkIcon> Live in Bangkok,Thailand
        </p>
        <div>
          <Button>Edit details</Button>
        </div>
      </div>
    </div>
  );
}

export default ProfileSide;
